export const GET_ACTIVITY = 'GET_ACTIVITY';// 获取所有活动
export const GET_ACTIVITY_DETAIL = 'GET_ACTIVITY_DETAIL';// 获取活动详情
export const GET_ACTIVITY_TYPE = 'GET_ACTIVITY_TYPE';// 获取活动类型
export const ADD_ACTIVITY = 'ADD_ACTIVITY';// 新增活动
export const EDIT_ACTIVITY = 'EDIT_ACTIVITY';// 编辑活动
export const DEL_ACTIVITY = 'DEL_ACTIVITY';// 删除活动
export const RECOMMEND_ACTIVITY = 'RECOMMEND_ACTIVITY';// 推荐活动


